module.exports = __webpack_public_path__ + "img/Testimoni_PaperID.f8bc64f8.png";